import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest, HTTP_INTERCEPTORS } from '@angular/common/http';
import { Provider } from '@angular/core';
import { RouterSelectors } from '@elio/emanager-front/shared/data-access/router';
import { BACKEND_URL } from '@elio/shared/models';
import { Store } from '@ngrx/store';
import { first, mergeMap, Observable } from 'rxjs';

export class HeadquarterInterceptor implements HttpInterceptor {
  private readonly HEADQUARTER_HTTP_HEADER = 'Elio-Headquarter';

  constructor(private store: Store) {}

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    return this.store.select(RouterSelectors.getHeadquarterIdFromRouteParam).pipe(
      first(),
      mergeMap((headquarterId) => {
        let newRequest = request;
        if (headquarterId && request.url.includes(BACKEND_URL)) {
          newRequest = request.clone({
            setHeaders: { [this.HEADQUARTER_HTTP_HEADER]: String(headquarterId) },
          });
        }
        return next.handle(newRequest);
      })
    );
  }
}

export const HEADQUARTER_INTERCEPTOR_PROVIDER: Provider = {
  provide: HTTP_INTERCEPTORS,
  useClass: HeadquarterInterceptor,
  multi: true,
  deps: [Store],
};
